import { makeAutoObservable } from 'mobx';

/**
 * @typedef {EN.Discipline} default
 */
export class Discipline {
  /**
   * @param {EN.Discipline} model
   */
  constructor(model) {
    makeAutoObservable(this);

    /** @type {EN.Discipline['id']} */
    this.id = '';
    /** @type {EN.Discipline['name']} */
    this.name = '';
    /** @type {EN.Discipline['shortName']} */
    this.shortName = '';
    /** @type {EN.Discipline['lid']} */
    this.lid = '';
    /** @type {EN.Discipline['pid']} */
    this.pid = '';
    /** @type {EN.Discipline['slug']} */
    this.slug = '';
    /** @type {EN.Discipline['category']} */
    this.category = 1;
    /** @type {EN.Discipline['isUnsubscribed']} */
    this.isUnsubscribed = false;

    Object.assign(this, model);
  }

  sortIndex = 0;

  tournamentIds = [];

  update(data) {
    Object.assign(this, data);
  }
}
